import { mapEducationInfoToValues } from '../../../../common';
import { EDUCATION_FORM_SCHEMA } from './validationSchema';

import type { ITreatmentPlanV3EducationPage } from '../../../../../store/treatmentPlanV3';

export function hasEducationFormErrors(page: ITreatmentPlanV3EducationPage) {
  if (page.not_attending_school) return false;
  return !EDUCATION_FORM_SCHEMA.isValidSync(mapEducationInfoToValues(page.education_info));
}
